import { CancelOutlined } from '@material-ui/icons';
import React from 'react';
import * as S from './styled';
import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';

export function ChatActions( {
	loadingCloseService,
	isCaseAssigned,
	isConversationEnded,
	onAssignCase,
	onEndConversation,
	caseId,
} ) {
	const [ open, setOpen ] = React.useState( false );
	const anchorRef = React.useRef( null );

	const handleToggle = () => {
		setOpen( ( prevOpen ) => !prevOpen );
	};

	const handleClose = ( event ) => {
		if ( anchorRef.current && anchorRef.current.contains( event.target ) ) {
			return;
		}

		setOpen( false );
	};

	function handleListKeyDown( event ) {
		if ( event.key === 'Tab' ) {
			event.preventDefault();
			setOpen( false );
		}
	}

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef( open );
	React.useEffect( () => {
		if ( prevOpen.current === true && open === false ) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [ open ] );

	return (
		<S.ActionContainer>
			<S.ChatCaseActions>
				<div>
					<Button
						ref={anchorRef}
						aria-controls={open ? 'menu-list-grow' : undefined}
						aria-haspopup="true"
						style={{ color: '#00A884' }}
						onClick={handleToggle}
					>
              Caso: {isCaseAssigned && caseId}
					</Button>
					<Popper
						open={open}
						anchorEl={anchorRef.current}
						role={undefined}
						transition
						disablePortal
						style={{ zIndex: 9999 }}
					>
						{( { TransitionProps, placement } ) => (
							<Grow
								{...TransitionProps}
								style={{
									position        : 'absolute',
									top             : '100%',
									left            : '0',
									transformOrigin : placement === 'bottom' ? 'center top' : 'center bottom',
									zIndex          : 9999
								}}
							>
								<Paper style={{ zIndex: 9999 }}>
									<ClickAwayListener onClickAway={handleClose}>
										<MenuList className='p-0' autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
											<MenuItem className='py-2 px-3' style={{ width: '100%', justifyContent: 'start' }} onClick={onAssignCase}>Editar</MenuItem>
											<MenuItem className='py-2 px-3' style={{ width: '100%', justifyContent: 'start' }} onClick={() => window.open( `${window.location.origin}/app/casos/${caseId.replace( /\D/g, '' )}`, '_blank' )}>Ir para o caso</MenuItem>
										</MenuList>
									</ClickAwayListener>
								</Paper>
							</Grow>
						)}
					</Popper>
				</div>
			</S.ChatCaseActions>
			<S.Divider />

			<S.ActionButton
				$danger
				disabled={isConversationEnded || loadingCloseService}
				$isEnded={isConversationEnded}
				onClick={onEndConversation}
			>
				<S.IconWrapper>
					<CancelOutlined size={14} />
				</S.IconWrapper>
				{loadingCloseService ? 'Finalizando...' : 'Finalizar'}
			</S.ActionButton>
		</S.ActionContainer>
	);
}

